import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { UserContext } from '../context/UserContext';

const MetasRoute = props => {
  const { isMonitor } = useContext(UserContext);

  if (isMonitor) {
    return <Route {...props} />;
  } else if (!isMonitor) {
    return <Redirect to='/login' />;
  } else {
    return null;
  }
};

export default MetasRoute;
